import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { inr } from "@/lib/api";
import { ENQ_STATUSES } from "@/lib/constants";
import { followState, followText, paxText, sourceLabel } from "@/lib/leads";

export const StatusSelect = ({ lead, onChange, className = "h-8 w-[150px]" }) => (
  <Select value={lead.status} onValueChange={(v) => onChange(lead, v)}>
    <SelectTrigger className={className} data-testid={`lead-status-select-${lead.id}`}><SelectValue /></SelectTrigger>
    <SelectContent className="bg-white">{ENQ_STATUSES.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
  </Select>
);

const FOLLOW_CLS = { overdue: "bg-rose-50 text-rose-700 border-rose-200", today: "bg-orange-50 text-orange-800 border-orange-200", upcoming: "bg-slate-50 text-slate-600 border-slate-200" };

export const FollowBadge = ({ lead }) => {
  const st = followState(lead);
  if (!st) return null;
  return <span data-testid={`lead-followup-${lead.id}`} className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${FOLLOW_CLS[st]}`}>
    {st === "overdue" ? "Overdue · " : st === "today" ? "Today · " : "Follow-up · "}{followText(lead)}
  </span>;
};

export const LeadMeta = ({ lead }) => (
  <div className="flex flex-wrap gap-1.5 text-[11px] font-semibold">
    {lead.trip_type && <span className="rounded-full bg-sky-50 text-ocean px-2 py-0.5" data-testid={`lead-trip-${lead.id}`}>{lead.trip_type}</span>}
    {lead.destination && <span className="rounded-full bg-cyan-50 text-cyan-800 px-2 py-0.5">{lead.destination}</span>}
    {lead.budget && <span className="rounded-full bg-amber-50 text-amber-800 px-2 py-0.5">{lead.budget}</span>}
    <span className="rounded-full bg-slate-100 text-slate-600 px-2 py-0.5" data-testid={`lead-source-${lead.id}`}>{sourceLabel(lead.source)}</span>
    <span className="rounded-full bg-slate-100 text-slate-600 px-2 py-0.5">{paxText(lead)}</span>
    {lead.quotation_amount > 0 && <span className="rounded-full bg-violet-50 text-violet-800 px-2 py-0.5" data-testid={`lead-quote-amount-${lead.id}`}>Quote {inr(lead.quotation_amount)}</span>}
    {lead.booking_status && <span className="rounded-full bg-emerald-50 text-emerald-800 px-2 py-0.5 capitalize" data-testid={`lead-booking-status-${lead.id}`}>Booking: {lead.booking_status}</span>}
  </div>
);
